import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { Icon } from '@pella/sash-framework';
import { getCookie, setCookie } from '../../../utilities/functions';
import { CTA } from '../../../';

import styles from './index.module.scss';

const HomepageToggle = ({ homeLink, proLink }) => {
	const [activeLink, setActiveLink] = useState('Homeowner');
	const [hasCookie, setHasCookie] = useState(true);
	const [showTooltip, setShowTooltip] = useState(true);

	useEffect(() => {
		if (getCookie('CustomerType') == null && typeof window !== 'undefined' && window.location) {
			if (window.location.pathname === '/professionals' || window.location.pathname === '/professionals/') {
				setActiveLink('Professional');
			} else {
				setActiveLink('Homeowner');
			}
		} else if (getCookie('CustomerType') != null) {
			setActiveLink(getCookie('CustomerType'));
		}

		if (getCookie('showTooltip') != null) {
			setHasCookie(true);
		} else {
			setHasCookie(false);
			setCookie('showTooltip', true);
		}
	}, []);

	const onLinkClick = (e, type) => {
		e.preventDefault();
		setCookie('CustomerType', type);
		navigate(e.currentTarget.href);
	};

	const tooltipToggle = () => setShowTooltip(!showTooltip);

	return (
		<div className={`header-typeToggle ${styles.homepageToggle}`}>
			{homeLink && (
				<CTA
					data={homeLink}
					className={activeLink === 'Homeowner' ? styles.homepageToggle_active : ''}
					onClick={(e) => onLinkClick(e, 'Homeowner')}
					renderAs='link'
				/>
			)}

			{proLink && (
				<CTA
					data={proLink}
					className={activeLink === 'Professional' ? styles.homepageToggle_active : ''}
					onClick={(e) => onLinkClick(e, 'Professional')}
					renderAs='link'
				/>
			)}

			{!hasCookie && showTooltip && (
				<div className={styles.homepageTooltip}>
					<div className={`${styles.homepageTooltip_Header} flex items-center`}>
						<p className='flex-1'>Welcome to Pella!</p>
						<button
							onClick={tooltipToggle}
							aria-label='Close Tooltip'
						>
							<Icon
								name='close'
								className='block'
							/>
						</button>
					</div>
					<div className={styles.homepageTooltip_Content}>
						<p>For a tailored experience on our website, please tell us who you are.</p>
					</div>
				</div>
			)}
		</div>
	);
};

HomepageToggle.propTypes = {
	homeLink: PropTypes.object,
	proLink: PropTypes.object,
};

export default HomepageToggle;
